<template>
	<div class="w100 h100">
		<transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
	</div>
</template>

<script>

export default {
	name: "layout",
	// components: {
	// 	Headers: () => import('./components/Headers')
	// },
};
</script>

<style lang="scss" scoped>
.w100 {
	width: 100%;
}
.h100 {
	height: 100%;
}
</style>
